<template>
	<div id="app" class="bg" :class="isDarkMode()">
		<router-view />
	</div>
</template>

<script>
import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import dayjs from 'dayjs';

export default {
	name: 'App',

	setup() {
		const store = useStore();
		const entrance = computed(() => store.getters['common/entrance']);

		const interval = ref();
		const nowHour = ref(dayjs().format('H'));
		const isDarkMode = () => {
			interval.value = setInterval(() => {
				nowHour.value = dayjs().format('H');
			}, 1000);
			// 4시 ~ 20시 주간모드, 이외에는 다크모드
			return nowHour.value >= 20 || nowHour.value < 4 ? 'dark-mode' : '';
		};

		watch(
			() => entrance.value,
			async entrance => {
				if (!entrance) {
					return;
				}
				if (entrance.bookableYn) {
					// 운행 가능한 날짜 목록(고정노선) 호출 - 목적지행
					const result = await store.dispatch('book/GET_BOOK_STEPS', {
						lineTypeCode: 'LRT-FORWAR',
						lineOnDemandTypeCode: 'LOD-NONE',
					});
					// 복귀행만 예약가능한 경우
					if (!result?.bookableDates?.length) {
						// 운행 가능한 날짜 목록(고정노선) 호출 - 복귀행
						await store.dispatch('book/GET_BOOK_STEPS', {
							lineTypeCode: 'LRT-BACKWA',
							lineOnDemandTypeCode: 'LOD-NONE',
						});
					}
				}
				if (entrance.etcYn) {
					// 운행 가능한 날짜 목록(기타노선) 호출 - 목적지행
					const result = await store.dispatch('book/GET_ETCBOOK_STEPS', {
						lineTypeCode: 'LRT-FORWAR',
						lineOnDemandTypeCode: 'LOD-FIXED',
					});
					// 복귀행만 예약가능한 경우
					if (!result?.bookableDates?.length) {
						// 운행 가능한 날짜 목록(기타노선) 호출 - 복귀행
						await store.dispatch('book/GET_ETCBOOK_STEPS', {
							lineTypeCode: 'LRT-BACKWA',
							lineOnDemandTypeCode: 'LOD-FIXED',
						});
					}
				}
			},
		);

		return { isDarkMode };
	},
};
</script>

<style src="@/assets/css/style.css"></style>
<style lang="scss">
@import '@/assets/scss/_index';
</style>
